import * as userService from '@/services/api/userService';
import { UserType } from '@/types/api/NewUser/User';

export async function changeUserId(user: UserType): Promise<UserType> {
    if (!user) {
        console.warn('User not found!')
    } else {
        const getUserByAuthentikId = await userService.getUserByAuthentikId(user.pk.toString());
        if (getUserByAuthentikId) {
            const userPk: number | string | null = getUserByAuthentikId?.userId;
            if (userPk) {
                user.pk = Number(userPk);
            }
        }   
    }
    return user;
}